<template>
  <div>
    <v-container class="form-control">
      <div class="text-xs-right">
        <v-btn color="primary" outline @click="showSelectPost = true">
          <template v-if="postidlist.length == 0">{{ $t('Select Post') }}</template>
          <template v-else
            >{{ $t('post') }} ({{ postidlist.length }})</template
          >
          <v-icon class="ml-1">edit</v-icon>
        </v-btn>
        <div class="form-control" :class="{ 'has-error': errors.has('post') }">
          <intent-select-post
            name="post"
            :data-vv-as="'Select Post'"
            v-validate="'required'"
            v-model="intent.postidlist"
            :show="showSelectPost"
            :singleselect="true"
            @close="showSelectPost = false"
          ></intent-select-post>
          <span class="text-error" v-if="errors.has('post')">{{ errors.first('post') }}</span>
        </div>
      </div>
      <v-layout wrap row>
        <v-flex xs12>
          <div class="form-control" :class="{ 'has-error': errors.has('name') }">
            <label>ชื่อ</label>
            <input
              name="name"
              v-validate="'required'"
              v-model="input.name"
              placeholder="Name"
              type="text"
            />
            <span class="text-error" v-if="errors.has('name')">{{ errors.first('name') }}</span>
          </div>
        </v-flex>
        <v-flex xs12>
          <div class="form-control" :class="{ 'has-error': errors.has('summary') }">
            <label>ข้อความสรุป</label>
            <input
              name="summary"
              v-validate="'required'"
              v-model="input.summarytext"
              placeholder="Summary Message"
              type="text"
            />
            <span class="text-error" v-if="errors.has('summary')">{{
              errors.first('summary')
            }}</span>
          </div>
        </v-flex>
        <v-flex xs12>
          <div class="form-control" :class="{ 'has-error': errors.has('warningtext') }">
            <label>ข้อความแจ้งเตือน</label>
            <input
              name="warningtext"
              v-validate="'required'"
              :data-vv-as="$t('Warning Text')"
              v-model="input.warningmessage"
              placeholder="Warning Message"
              type="text"
            />
            <span class="text-error" v-if="errors.has('warningtext')">{{
              errors.first('warningtext')
            }}</span>
          </div>
        </v-flex>
        <v-flex xs12>
          <div class="form-control" :class="{ 'has-error': errors.has('warningtextformat') }">
            <label>ข้อความแจ้งเตือน (ไม่ตรงตามรูปแบบ)</label>
            <input
              name="warningtextformat"
              v-validate="'required'"
              :data-vv-as="$t('Warning Text Format')"
              v-model="input.msginvalidformat"
              placeholder="Warning Message Format"
              type="text"
            />
            <span class="text-error" v-if="errors.has('warningtextformat')">{{
              errors.first('warningtextformat')
            }}</span>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="form-control pr-1" :class="{ 'has-error': errors.has('minprice') }">
            <label>ต่ำสุด</label>
            <input
              name="minprice"
              v-validate="'required'"
              :data-vv-as="$t('Min Price')"
              v-model="input.minprice"
              placeholder="Min"
              type="number"
            />
            <span class="text-error" v-if="errors.has('minprice')">{{
              errors.first('minprice')
            }}</span>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="form-control pl-1" :class="{ 'has-error': errors.has('maxprice') }">
            <label>สูงสุด</label>
            <input
              name="maxprice"
              v-validate="'required'"
              :data-vv-as="$t('Max price')"
              v-model="input.maxprice"
              placeholder="Max"
              type="number"
            />
            <span class="text-error" v-if="errors.has('maxprice')">{{
              errors.first('maxprice')
            }}</span>
          </div>
        </v-flex>
        <v-flex xs6 class="form-control" :class="{ 'has-error': errors.has('date') }">
          <v-menu
            ref="openStartDate"
            v-model="openStartDate"
            :close-on-content-click="false"
            full-width
            max-width="290px"
            color="primary"
          >
            <template v-slot:activator="{ on }">
              <label>วันที่</label>
              <input
                type="text"
                class="form-control browser-default"
                :placeholder="$t('Date')"
                readonly
                v-validate="'required'"
                :data-vv-as="$t('Date')"
                name="date"
                v-model="input.startDate"
                v-on="on"
                clearable
              />
            </template>

            <v-date-picker
              :allowed-dates="allowedDates"
              color="primary"
              v-model="input.startDate"
              @input="openStartDate = false"
            ></v-date-picker>
          </v-menu>
          <span class="text-error" v-if="errors.has('date')">{{ errors.first('date') }}</span>
        </v-flex>
        <v-flex xs4 class="form-control pl-2" :class="{ 'has-error': errors.has('time') }">
          <v-menu
            ref="openStartTime"
            v-model="openStartTime"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="input.startTime"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :disabled="input.startDate == null"
          >
            <template v-slot:activator="{ on }">
              <label>เวลา</label>
              <input
                type="text"
                class="form-control browser-default"
                :placeholder="$t('Time')"
                readonly
                v-validate="'required'"
                :data-vv-as="$t('Time')"
                name="time"
                v-model="input.startTime"
                v-on="on"
                :disabled="!input.startDate"
              />
            </template>
            <v-time-picker
              v-if="openStartTime"
              v-model="input.startTime"
              :allowed-hours="allowedHours"
              :allowed-minutes="allowedMinutes"
              full-width
              format="24hr"
              @click:minute="$refs.openStartTime.save(input.startTime)"
            ></v-time-picker>
          </v-menu>
          <span class="text-error" v-if="errors.has('time')">{{ errors.first('time') }}</span>
        </v-flex>
      </v-layout>
      <div class="text-xs-center">
        <v-btn @click.stop="$emit('close')" color="grey" outline>CANCEL</v-btn>
        <v-btn v-if="data" :loading="loading" @click.stop="updateData" color="primary" depressed
          >UPDATE</v-btn
        >
        <v-btn v-else :loading="loading" @click.stop="saveData" color="primary" depressed
          >SAVE</v-btn
        >
      </div>
    </v-container>
  </div>
</template>

<script>
import IntentSelectPost from '@/components/view/intent/AstonIntentSelectPost.vue'
import { mapGetters } from 'vuex'
import api from '@/api'
import dayjs from 'dayjs'

export default {
  props: ['data'],
  components: {
    IntentSelectPost
  },
  computed: {
    postidlist: function() {
      var vm = this
      if (vm.intent.postidlist && vm.intent.postidlist !== '') {
        return vm.intent.postidlist.split(',')
      } else {
        return []
      }
    },
    ...mapGetters(['selectedBot'])
  },
  data() {
    return {
      openStartDate: false,
      loading: false,
      openStartTime: false,
      showSelectPost: false,
      intent: {
        postidlist: ''
      },
      input: {
        summarytext: '',
        warningmessage: '',
        msginvalidformat: '',
        minprice: '',
        maxprice: '',
        startDate: '',
        startTime: '',
        name: ''
      }
    }
  },
  created() {
    if (this.data) {
      this.input = this.data
      this.intent.postidlist = this.data.postid
      this.input.startDate = dayjs(this.data.endtime).format('YYYY-MM-DD')
      this.input.startTime = dayjs(this.data.endtime).format('HH:mm')
    }
  },
  methods: {
    allowedDates(val) {
      return dayjs().diff(val, 'days') < 1
    },
    allowedHours(val) {
      if (this.input.startDate) {
        var iscurrentDate = dayjs(this.input.startDate).isSame(new Date(), 'day')
        if (iscurrentDate) {
          return parseFloat(dayjs().format('HH')) - val < 1
        } else {
          return true
        }
      }
    },
    allowedMinutes(val) {
      return [0, 30].includes(val)
    },
    saveData() {
      var vm = this
      vm.$validator.validateAll().then(result => {
        if (!result) {
          return false
        }

        vm.loading = true
        var data = {
          ...this.input,
          endtime: this.input.startDate + ' ' + this.input.startTime + ':00' + dayjs().format('Z'),
          postid: this.intent.postidlist,
          pageid: this.selectedBot.pageid
        }
        api.postauctionfbpost(data, (err, response) => {
          vm.loading = false
          if (err && err instanceof Error) {
            return vm.$swal.fire({
              type: 'error',
              text: err,
              confirmButtonText: 'CLOSE',
              confirmButtonColor: vm.$vuetify.theme.primary
            })
          }
          if (response.responsecode == 200) {
            vm.$emit('onSave', { ...data, id: response.id })
          } else if (response.responsecode == 401) {
            vm.$swal.fire({
              type: 'error',
              text: 'การประมูลซ้ำ กรุณาลองใหม่อีกครั้ง'
            })
          }
        })
      })
    },
    updateData() {
      var vm = this
      vm.$validator.validateAll().then(result => {
        if (!result) {
          return false
        }

        vm.loading = true
        var data = {
          ...this.input,
          endtime: this.input.startDate + ' ' + this.input.startTime + ':00' + dayjs().format('Z'),
          postid: this.intent.postidlist,
          pageid: this.selectedBot.pageid
        }
        api.putauctionfbpost(data, (err, response) => {
          vm.loading = false
          if (response.responsecode == 200) {
            vm.$emit('onUpdate', data)
          } else if (response.responsecode == 401) {
            vm.$swal.fire({
              type: 'error',
              text: 'การประมูลซ้ำ กรุณาลองใหม่อีกครั้ง'
            })
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/AstonAuctionManager.vue